import { styled } from "@mui/material";

import { AlertBox, AlertBoxProps } from "@/components";
import { COLORS } from "@/utils/colors";

type StyleProps = {
  strong?: boolean;
};

export type Props = Omit<AlertBoxProps, "severity" | "icon"> & StyleProps;

export const AlertWarning: React.FC<Props> = (props) => {
  return <StyledAlert {...props} severity="warning" />;
};

const StyledAlert = styled(AlertBox, {
  shouldForwardProp: (propName: PropertyKey) => propName !== "strong",
})<StyleProps>(({ strong }) => ({
  backgroundColor: COLORS.WARNING_BG,
  color: strong ? COLORS.WARNING : undefined,
}));
